import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Grid,
  Icon,
} from "@material-ui/core";
import { isEmpty, isNil, propEq, filter } from "ramda";
import Button from "@material-ui/core/Button";
import Table from "../../../../design-system/components/Table/Table";
import NothingFound from "../../../../components/NothingFound/NothingFound";
import LoaderContent from "../../../../design-system/components/Loader/LoaderContent";
import { usersColumns } from "../ColumnsTable";
import { v4 as uuid } from "uuid";
import isEmail from "../../../../utils/isEmail";
import DeleteIcon from "@material-ui/icons/Delete";

import FormUsers from "./FormUsers";
import NewItem from "../Components/NewItem";

// @sdk
import { MembershipManagmentB2BService } from "@sdk-point/talisis";
import Toast from '../../../../design-system/components/Toast/Toast';
import { commonModuleStyles } from '../../../../assets/styles/jss/pages/common/CommonModuleStyles';
import useMembershipCatalogs from '../useMembershipCatalogs';

import PropTypes from "prop-types";

//se crea la variable para el llamado
const MembershipManagmentB2BServiceSDK = new MembershipManagmentB2BService(
  process.env.REACT_APP_ENV_V2,
  process.env.REACT_APP_X_API_KEY_V2
);

const initFormData = {
  error: {},
  form: {
    addon: "",
    attribute1: "",
    attribute2: "",
    attribute3: "",
    email: "",
    group: "",
    lastNameMaternal: "",
    lastNamePaternal: "",
    membership: "",
    name: "",
    program: "",
    time: "",
  },
};

const Details = (props) => {
  const { dataGeneral, dataAttribute } = props;

  const classes = commonModuleStyles();
  const user = useSelector((state) => state.userReducer.user);
  const [loading, setLoading] = React.useState(false);
  const [loadStep, setLoadStep] = React.useState('');
  const [emailValidate, setEmailValidate] = React.useState(false);
  const [state, setState] = React.useState({ data: [], totalPages: 0, dataSource: [], });


  const [periodOptions, setPeriodOptions] = React.useState([]);
  const [programOptions, setProgramOptions] = React.useState([]);
  // Membresías y addons vienen del hook COMPARTIDO (misma llamada que usa el
  // cambio de membresía en Modificaciones; se pide una sola vez por sesión).
  // getPeriods carga los plazos de una membresía bajo demanda.
  const { membershipOptions, addonOptions, getPeriods } = useMembershipCatalogs();
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [disabledAddon, setDisabledAddon] = React.useState(false);
  const [formData, setFormData] = React.useState(initFormData);
  const [toastProps, setToastProps] = React.useState({ message: ""});

  const [openNewAttributeModal, setOpenNewAttributeModal] = React.useState(false);
  const [attributeOptions, setAttributeOptions] = React.useState(dataAttribute);
  const [attributeFieldOrigin, setAttributeFieldOrigin] = React.useState(null);

  const limitUsers = 8;
  const columns = usersColumns;
  const messageTable = {
    data: {
      caption: "Intentalo de nuevo.",
      subtitle: "No se encuentra ninguna información.",
    },
  };

  useEffect(() => {
    // Las membresías/addons ya los provee useMembershipCatalogs (hook compartido).
    // Aquí solo se inicializa el grupo del formulario con el de la empresa.
    setFormData((prevState) => ({
      ...prevState,
      form: { ...prevState.form, group: dataGeneral.group.id },
    }));
  }, []);

  // Sincronizar atributos cuando cambian desde el padre
  useEffect(() => {
    setAttributeOptions(dataAttribute);
  }, [dataAttribute]);

  const handleCloseAttributeModal = () => setOpenNewAttributeModal(false);

  const handleAttributeClick = (fieldName) => {
    setAttributeFieldOrigin(fieldName);
    setOpenNewAttributeModal(true);
  };

  const handleSubmitAttribute = async (data) => {
    const payload = {
      tagType: "custom",
      displayName: data.value,
      companyId: dataGeneral.company.id,
      companyName: dataGeneral.company.label
    };

    // Cerrar modal inmediatamente
    setOpenNewAttributeModal(false);

    try {
      await MembershipManagmentB2BServiceSDK.postCreateCompanies(payload);

      // Refrescar atributos custom
      const attributeData = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({
        type: 'custom',
        companyId: dataGeneral.company.id
      });
      if (attributeData.success && attributeData.data) {
        const attributes = attributeData.data.map((item) => ({
          id: item.id,
          label: item.display_name,
          value: item.id,
          tag: item.tag
        }));
        setAttributeOptions(attributes);

        // Auto-seleccionar el nuevo atributo en el campo origen
        const newAttribute = attributes.find(attr => attr.label === data.value);
        if (newAttribute && attributeFieldOrigin) {
          setFormData((prev) => ({
            ...prev,
            form: { ...prev.form, [attributeFieldOrigin]: newAttribute.id },
            error: { ...prev.error, [attributeFieldOrigin]: undefined },
          }));
        }
      }
      setToastProps({ severity: "success", open: true, message: "El atributo ha sido creado exitosamente." });
    } catch (e) {
      setToastProps({ severity: "error", open: true, message: "Ocurrió un error. Por favor inténtalo de nuevo." });
    }
    setAttributeFieldOrigin(null);
  };


  const handleDeleteUser = (id) => {
    setState((prevState) => ({
      ...prevState,
      data: prevState.data.filter((it) => it.id !== id),
    }));
  };

  const handleFinishedToast = () => {
    const _toastProps = { ...toastProps };
    _toastProps.open = false;
    setToastProps(_toastProps);
  };

  const handleAddUser = (e) => {
    e.preventDefault();
    setLoadingSave(true);
    let { form } = formData;
    let error = {};
    let messageError = "Es requerido.";

    // Validación de campos requeridos
    Object.keys(form).forEach((key) => {
      // Validación para campos vacíos
      const excludedKeys = ["addon", "program", "attribute1", "attribute2", "attribute3"];

      if (isEmpty(form[key]) && !excludedKeys.includes(key)) {
        error[key] = messageError;
      }
      // Validación especial para addon
      /*else if (!disabledAddon && key === "addon" && isEmpty(form[key])) {
        error[key] = messageError;
      }*/
      // Validación especial para email
      else if (key === "email" && !emailValidate) {
        error[key] = messageError;
      }
    });

    setFormData((prevState) => ({ ...prevState, error }));

    if (!isEmpty(error)) {
      setLoadingSave(false);
      return;
    }

    let newUser = {
      ...form,
      id: uuid(),
      membership: filter(propEq(form.membership, "id"), membershipOptions)[0],
      addon: !isEmpty(form.addon)
        ? filter(propEq(form.addon, "id"), addonOptions)[0]
        : { label: "", id: "" },
      program: !isEmpty(form.program)
        ? filter(propEq(form.program, "id"), programOptions)[0]
        : { label: "", id: "" },
      period: filter(propEq(form.time, "id"), periodOptions)[0],
      attribute1: !isEmpty(form.attribute1)
        ? filter(propEq(form.attribute1, "id"), attributeOptions)[0]
        : { label: "", id: "" },
      attribute2: !isEmpty(form.attribute2)
        ? filter(propEq(form.attribute2, "id"), attributeOptions)[0]
        : { label: "", id: "" },
      attribute3: !isEmpty(form.attribute3)
        ? filter(propEq(form.attribute3, "id"), attributeOptions)[0]
        : { label: "", id: "" },
      group: !isNil(dataGeneral.group.id) ? dataGeneral.group :
        !isEmpty(form.group)
          ? filter(propEq(form.group, "id"), props.cataloguesGroup)[0]
          : { label: "", id: "" },
      status: "",
      personId: "",
      fullName:
        form.name + " " + form.lastNamePaternal + " " + form.lastNameMaternal,
    };


    newUser = {
      ...newUser,
      actions: (
        <Button
          variant="contained"
          startIcon={<DeleteIcon />}
          onClick={() => handleDeleteUser(newUser.id)}
        >
          Eliminar
        </Button>
      ),

    }

    setState((prevState) => ({
      ...prevState,
      data: [...prevState.data, newUser],
    }));

    setFormData({
      ...initFormData,
      form: { ...initFormData.form, group: dataGeneral.group.id },
    });
    setLoadingSave(false);
  };

  const handleVerifyEmail = async ({ target: { name, value } }) => {
    // Verifica si el correo contiene espacios
    if (/\s/.test(value)) {
      const emailError = "El correo no debe contener espacios.";
      setEmailValidate(false);
      setFormData((prevState) => ({
        ...prevState,
        error: { ...prevState.error, [name]: emailError },
      }));
      return;
    }



    if (isNil(value) || !isEmail(value)) return;
    const response = await MembershipManagmentB2BServiceSDK.postVerifyEmail({
      email: value,
    });
    const emailError =
      response.success && response.exists ? "El correo ya existe." : false;
    setEmailValidate(!emailError);
    setFormData((prevState) => ({
      ...prevState,
      error: { ...prevState.error, [name]: emailError },
    }));
  };

  const handleOnChange = async ({ target: { value, name } }) => {
    // Filtramos las opciones de atributos basándonos en todos los valores seleccionados
    if (name.includes("attribute")) {
      const { attribute1, attribute2, attribute3 } = formData.form;
      let error = {};
      let messageError = "Este atributo ya está seleccionado en otro campo";

      // Validamos que el valor seleccionado no sea igual a los otros atributos
      if (
        name.includes("attribute") &&
        ((name === "attribute1" &&
          ((value && attribute2 && value === attribute2) || (value && attribute3 && value === attribute3))) ||
          (name === "attribute2" &&
            ((value && attribute1 && value === attribute1) || (value && attribute3 && value === attribute3))) ||
          (name === "attribute3" &&
            ((value && attribute1 && value === attribute1) || (value && attribute2 && value === attribute2))))
      ) {
        error[name] = messageError;
      }

      // Actualizamos el estado con el error si existe o lo removemos si no hay error
      setFormData((prev) => {
        const newError = { ...prev.error };
        if (error[name]) {
          newError[name] = error[name];
        } else {
          delete newError[name];
        }
        return {
          ...prev,
          error: newError,
        };
      });
    }

    // Actualizamos el estado del formulario
    setFormData((prev) => ({
      ...prev,
      form: { ...prev.form, [name]: value },
    }));

    if (name === "membership") {
      setPeriodOptions([]);
      setProgramOptions([]);
      // Plazos vía el hook compartido (mismo endpoint/mapeo que Modificaciones).
      const period = await getPeriods(value);
      setPeriodOptions(period);

      const programData =
        await MembershipManagmentB2BServiceSDK.getCatalogPrograms({
          id: value,
        });
      if (programData.success) {
        // En pantalla se muestra el nombre legible del programa (nameProgram, ej.
        // "Bachillerato"). El value (id) NO cambia, así que lo que se envía
        // internamente al guardar (user.program.id) sigue siendo lo mismo que ya
        // teníamos. Fallback a item.program si el backend no trae nameProgram, para
        // no quedar con un label vacío.
        let program = programData.data.map((item) => ({
          id: item.id,
          label: item.nameProgram || item.program,
        }));
        setProgramOptions(program);
      }
    }

    if (name === "time") {
      setDisabledAddon(false);
      if (value.includes("-1M")) {
        setDisabledAddon(true);
        setFormData((prevState) => ({
          ...prevState,
          form: { ...prevState.form, addon: "" },
        }));
      }
    }
  };

  const handleSendUsers = async () => {
    setLoading(true);
    setLoadStep('Preparando datos de usuarios...');

    try {
      // Respeta la selección del usuario (dataGeneral.email === 1 => "Si" => enviar correo).
      const sendEmail = (dataGeneral.email === 1) || false;
      let payloadCreateUsers = {
        sendEmail: sendEmail || false,
        userPersonId: user.person_id,
        users: state.data.map((user) => ({
          firstName: user.name,
          lastName: user.lastNamePaternal + " " + user.lastNameMaternal,
          emailAddress: user.email,
          phone: "",
          tags: {
            company: dataGeneral.company.id,
            group: !isNil(dataGeneral.group.id) ? dataGeneral.group.id : user.group.id,
            attribute1: user.attribute1.id,
            attribute2: user.attribute2.id,
            attribute3: user.attribute3.id,
          },
          membership: user.period.id,
          addon: user.addon.id,
          paymentReferenceId: "B2B-" + dataGeneral.company.tag.split('=')[1],
          program: user.program.id
        })),
      };

      console.log('payloadCreateUsers', payloadCreateUsers);

      setLoadStep('Creando usuarios y membresías...');
      const response = await MembershipManagmentB2BServiceSDK.postCreateUsers(payloadCreateUsers);
      console.log('responseCreateUsers', response);

      // Handle partial results if the response has detail
      if (response && response.results) {
        const successCount = response.results.filter(r => r.success || r.status === 'success').length;
        const failCount = response.results.filter(r => !r.success && r.status !== 'success').length;

        if (failCount > 0 && successCount > 0) {
          // Partial success
          setLoadStep('Proceso completado con errores parciales');
          const errorDetails = response.results
            .filter(r => !r.success && r.status !== 'success')
            .map(r => `${r.email || r.emailAddress || 'Usuario'}: ${r.message || r.error || 'Error desconocido'}`)
            .join('\n');
          setToastProps({
            severity: "warning",
            open: true,
            message: `${successCount} usuario(s) creado(s) exitosamente. ${failCount} usuario(s) con errores: ${errorDetails}`
          });
        } else if (failCount > 0 && successCount === 0) {
          // All failed
          setLoadStep('');
          const errorMsg = response.results
            .map(r => `${r.email || r.emailAddress || 'Usuario'}: ${r.message || r.error || 'Error'}`)
            .join(', ');
          setToastProps({
            severity: "error",
            open: true,
            message: `Error en la creación: ${errorMsg}`
          });
        } else {
          // All success
          setLoadStep('Proceso completado exitosamente');
          setToastProps({
            severity: "success",
            open: true,
            message: `${successCount} usuario(s) creado(s) exitosamente.`
          });
        }
      } else {
        setLoadStep('Proceso completado');
        setToastProps({ severity: "success", open: true, message: "Los registros han sido procesados exitosamente." });
      }

    } catch (error) {
      console.error("Error creando usuarios", error);
      setLoadStep('');
      // Show backend error message if available (abort-on-failure)
      const backendMessage = error?.response?.data?.message
        || error?.response?.data?.error
        || error?.message
        || "Ha ocurrido un error al crear usuarios.";
      setToastProps({
        severity: "error",
        open: true,
        message: backendMessage
      });
    } finally {
      setLoading(false);
      setTimeout(() => setLoadStep(''), 3000);
    }
  };


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title={
              <Typography
                variant="h4"
                color="primary"
                component={"div"}
                gutterBottom
                style={{fontWeight: 600}}
              >
                Agregar Usuarios
              </Typography>
            }
            action={
              <Button
                variant="contained"
                startIcon={
                  <Icon className="ri-arrow-left-s-line font-size-24 text-dark-black-200" />
                }
                onClick={() => props.onClose()}
              >
                Regresar
              </Button>
            }
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item md={12} className={classes.infoRow}>
                        <Typography
                          color={"primary"}
                          variant={"body2"}
                          component={"span"}
                          style={{fontWeight: 500}}
                        >
                          Empresa:{" "}
                        </Typography>
                        <Typography component={"span"} variant={"body2"}>
                          {dataGeneral.company.label}
                        </Typography>
                      </Grid>
                      <Grid item md={12} className={classes.infoRow}>
                        <Typography
                          color={"primary"}
                          variant={"body2"}
                          component={"span"}
                          style={{fontWeight: 500}}
                        >
                          Grupo:{" "}
                        </Typography>
                        <Typography component={"span"} variant={"body2"}>
                          {dataGeneral.group.label}
                        </Typography>
                      </Grid>
                      <Grid item md={12} className={classes.infoRow}>
                        <Typography
                          color={"primary"}
                          variant={"body2"}
                          component={"span"}
                          style={{fontWeight: 500}}
                        >
                          Enviar Correo:{" "}
                        </Typography>
                        <Typography component={"span"} variant={"body2"}>
                          {dataGeneral.email === 1 ? "SI" : "NO"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <LoaderContent loading={loadingSave}>
                      <FormUsers
                        dataprincipal={dataGeneral}
                        attribute={attributeOptions}
                        period={periodOptions}
                        program={programOptions}
                        membership={membershipOptions}
                        addon={addonOptions}
                        loading={loadingSave}
                        data={formData.form}
                        error={formData.error}
                        disabledAddon={disabledAddon}
                        handleAddUser={handleAddUser}
                        onChange={handleOnChange}
                        handleVerifyEmail={handleVerifyEmail}
                        disabledAdd={state.data.length > limitUsers - 1}
                        groupOptions={props.cataloguesGroup}
                        onAttributeClick={handleAttributeClick}
                      />
                    </LoaderContent>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <LoaderContent loading={loading} minHeight={500}>
                      {state.data.length > 0 ? (
                        <React.Fragment>
                          <Table
                            checkboxs={false}
                            maxHeight={"800px"}
                            columns={columns}
                            rows={state.data}
                            checkboxDisabledIcon={false}
                          />
                          <Box className={classes.actionButtonContainer}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleSendUsers}
                              disabled={loading}
                            >
                              Enviar Usuarios
                            </Button>
                          </Box>
                          {loading && loadStep && (
                            <Box mt={2} textAlign="center">
                              <Typography variant="body2" color="textSecondary">{loadStep}</Typography>
                            </Box>
                          )}
                        </React.Fragment>
                      ) : (
                        !loading && (
                          <NothingFound
                            width="200px"
                            caption={messageTable.data.caption}
                            subcaption={messageTable.data.subtitle}
                          />
                        )
                      )}
                      <Toast {...toastProps} onFinished={handleFinishedToast} />
                      <NewItem
                        openModal={openNewAttributeModal}
                        handleClose={handleCloseAttributeModal}
                        title="Atributo"
                        label="Atributo"
                        name="custom"
                        handleSubmit={handleSubmitAttribute}
                      />
                    </LoaderContent>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

Details.propTypes = {
  dataGeneral: PropTypes.object.isRequired,
  dataAttribute: PropTypes.array.isRequired,
};

export default Details;
